import { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { format } from 'date-fns';
import Select from 'react-select';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import { post } from '../Auths/AuthToken';
import UploadDocsSec from './UploadDocsSec';
import ViewUplodDocsSec from './ViewUplodDocsSec';
import setUiMessage from '../../Utilities/Tostify';
import PatientSerchPopUpForApp from '../PatientSerchPopUpForApp';
import DocsNotePopup from './DocsNotePopup';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button';
import { handleGlobalReload } from '../../redux/slices/appSlice';

const getSelectedOption = (options, value) =>
  (options || []).find((o) => String(o.value) === String(value)) || null;

const buildOptions = (arr, valueKey, labelKey) =>
  (arr || []).map((item) => ({
    value: item?.[valueKey],
    label: item?.[labelKey],
  }));

const getGroupedSelectedOption = (groups, value) => {
  for (const group of groups || []) {
    const found = getSelectedOption(group.options, value);
    if (found) return found;
  }
  return null;
};

const buildAllocateUserOptions = (allocateUserList) => {
  if (!allocateUserList) return [];
  const groups = [
    ['Administrator', allocateUserList.Administrator],
    ['Clinical', allocateUserList.Clinical],
    ['Doctor', allocateUserList.Doctor],
    ['Front Desk', allocateUserList.Front_Desk],
  ];
  return groups
    .filter(([, users]) => users?.length)
    .map(([label, users]) => ({
      label,
      options: buildOptions(users, 'id', 'userName'),
    }));
};

const selectMenuStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 1100 }),
};

function UploadDocPopUp({
  close,
  patientId,
  docsId = '',
  handleReload,
  parentDocsId,
}) {
  const { user } = useSelector((state) => state.auth);
  const { selectedSerchPat } = useSelector((state) => state.patient);
  const { globalReload } = useSelector((store) => store.app);
  const dispatch = useDispatch();

  const [allData, setAllData] = useState(null);

  const [patId, setPatId] = useState(patientId || '');

  const [provider, setProvider] = useState(
    allData?.provider_id ? allData?.provider_id : user?.id
  );
  const [providerList, setProviderList] = useState(null);

  const [docStatus, setDocStatus] = useState(1);
  const [docStatusList, setDocStatusList] = useState(null);

  const [docType, setDocType] = useState(allData?.docType);
  const [docTypeList, setDocTypeList] = useState(null);

  const [userAllocated, setUserAllocated] = useState(allData?.aUser || 0);
  const [allocateUserList, setAllocateUserList] = useState(null);

  const [docName, setDocName] = useState(allData?.docName || '');

  const [docDate, setDocDate] = useState(new Date());
  const [notes, setNotes] = useState('');
  const [fileNameArr, setfileNameArr] = useState([]);
  const [counter, setCounter] = useState(0);

  const [patSerchPopup, setPatSerchPopup] = useState(false);
  const [docsNote, setDocsNote] = useState(false);
  const [docsNotePopUp, setDocsNotePopUp] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/ManagePatientDocument/addEditDocumentPopup',
          {
            docId: docsId, //when edit document
            table: '0', //when edit document
            //locationC: '1',
            patientId: patId,
            reconId: '',
          }
        );
        if (response?.status === 200) {
          setAllData(response?.data);
          setProviderList(response?.data?.resourceList);
          setDocStatusList(response?.data?.documentStatusList);
          setDocTypeList(response?.data?.docTypeList);
          setAllocateUserList(response?.data?.allocateUser);
          setDocsNote(response?.data?.userNoteArr);
          if (docsId) {
            setProvider(response?.data?.getRecord?.provider_id);
            setDocStatus(response?.data?.getRecord?.status);
            setDocType(response?.data?.getRecord?.doc_type);
            setUserAllocated(response?.data?.getRecord?.user_id);
            setDocName(response?.data?.getRecord?.doc_name);
            setDocDate(
              response?.data?.getRecord?.doc_date &&
                response?.data?.getRecord?.doc_date !== '0000-00-00' &&
                new Date(response?.data?.getRecord?.doc_date)
            );

            let fileArr = {
              fileName: response.data?.fileName,
              encrtption: response.data?.hashKey,
              filePath: response.data?.filePath,
              parentId: 0,
              fileNum: 1,
              pages: response.data?.docPageArr
                ? response.data?.docPageArr?.map((ele, i) => {
                    return {
                      fileName: ele?.fileName,
                      encrtption: ele?.hashKey,
                      filePath: ele?.filePath,
                      parentId: 1,
                      fileNum: 1 + (i + 1),
                    };
                  })
                : [],
            };

            setfileNameArr((ele) => {
              return [...ele, fileArr];
            });
          }
        }
      } catch (e) {}
    })();
  }, [patId, docsId]);

  useEffect(() => {
    if (selectedSerchPat?.patId) setPatId(selectedSerchPat?.patId);
  }, [selectedSerchPat]);

  const handleSubmit = async (e) => {
    var attachStr = '';
    for (let i in fileNameArr) {
      attachStr += `${fileNameArr[i].fileName}|${fileNameArr[i].encrtption}|${fileNameArr[i].parentId}|${fileNameArr[i].fileNum}!@#`;

      if (fileNameArr[i].pages.length > 0) {
        for (let j in fileNameArr[i].pages) {
          attachStr += `${fileNameArr[i].pages[j].fileName}|${fileNameArr[i].pages[j].encrtption}|${fileNameArr[i].pages[j].parentId}|${fileNameArr[i].pages[j].fileNum}!@#`;
        }
      }
    }

    if (
      !patId ||
      !provider ||
      !docType ||
      !attachStr ||
      !docName ||
      //!userAllocated ||
      !docStatus
    ) {
      if (!patId) {
        setUiMessage('err', 'Please select Patient.');
      }
      if (!attachStr) {
        setUiMessage('err', 'Please select file.');
      }
      if (!provider) {
        setUiMessage('err', 'Please select Provider.');
      }
      if (!docType) {
        setUiMessage('err', 'Please select document type,');
      }
      if (!docName) {
        setUiMessage('err', 'Please select document name.');
      }
      if (!docStatus) {
        setUiMessage('err', 'Please select document status.');
      }
    } else {
      try {
        const response = await post(
          'api/patient/ManagePatientDocument/saveUpdateDocumentInfo',
          {
            action: docsId ? 'Update' : 'add',
            patientId: patId,
            docDescription: '',
            docStatus: docStatus,
            userTypeId: userAllocated, //alocat to user
            userComment: notes,
            allAttachment: attachStr,
            attachDocId: docsId, //docId
            parentId: parentDocsId || 0,
            providerId: provider,
            documentType: docType,
            docName: docName,
            attachFaxId: '',
            reconId: '',
            docDate: docDate
              ? format(new Date(docDate), DEFAULT_DATE_FORMATE)
              : '',
            loginUserId: user?.id,
          }
        );
        if (response?.status === 200) {
          setUiMessage('suc', 'Data save successfully.');
          close();
          handleReload();
          dispatch(handleGlobalReload(!globalReload));
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    }
  };

  const handleUploadCallBack = (data, parentId = 0) => {
    setCounter(counter + 1);
    if (parentId) {
      let newObj = {
        ...data,
        parentId: parentId,
        fileNum: counter + 1,
      };
      let foundObject = fileNameArr.find((obj) => obj.fileNum === parentId);

      if (foundObject) {
        foundObject['pages'].push(newObj);
      }
    } else {
      let newObj = {
        ...data,
        parentId: parentId,
        fileNum: counter + 1,
        pages: [],
      };
      setfileNameArr((ele) => {
        return [...ele, newObj];
      });
    }
  };

  const handleRemoveCallBack = (fileNum, isPatent) => {
    if (isPatent) {
      let a = fileNameArr.filter((obj) => obj.fileNum !== fileNum);
      setfileNameArr(a);
    } else {
      let updatedData = fileNameArr.map((obj) => {
        if (obj.pages && Array.isArray(obj.pages)) {
          obj.pages = obj.pages.filter((page) => page.fileNum !== fileNum);
        }
        return obj;
      });
      setfileNameArr(updatedData);
    }
  };

  const handleAttachPatient = () => {
    setPatSerchPopup(true);
  };

  return (
    <div className="modalBackground">
      <div className="white-bg upload-doc-popup">
        <div className="flex-sec item-center justify-between">
          {patId ? (
            <div className="hdr-pt-info">
              {allData?.patientName}
              <span className="red"> | </span>
              ID: {allData?.chartNo}
              <span className="red"> | </span>
              {allData?.age} yrs-[{allData?.gender?.substr(0, 1)}]
              <span className="red"> | </span>
              DOB:{allData?.dob}
            </div>
          ) : (
            <div className="hdr-pt-info">
              <Button variant="primary" onClick={handleAttachPatient}>
                Attach patient
              </Button>
            </div>
          )}

          <Button variant="circle" onClick={close}>
            X
          </Button>
        </div>
        <div className="insu-act-sec-bdy">
          <div className="insu-act-sec-hdr">Upload Document:</div>

          <UploadDocsSec uploadCb={handleUploadCallBack} />
          <ViewUplodDocsSec
            inputData={fileNameArr}
            uploadCb={handleUploadCallBack}
            removeCb={handleRemoveCallBack}
          />

          <div className="insu-act-sec-hdr">Other Details:</div>
          <div className="insu-act-sec-bdy-rw flex-sec">
            <div className="insu-act-sec-bdy-lft flex-sec">
              <span className="nsu-act-lbl">Provider:</span>
              <span className="nsu-act-val">
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select provider"
                  isClearable
                  options={buildOptions(providerList, 'id', 'providerName')}
                  value={getSelectedOption(
                    buildOptions(providerList, 'id', 'providerName'),
                    provider
                  )}
                  onChange={(opt) => setProvider(opt?.value ?? '')}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={selectMenuStyles}
                />
              </span>
            </div>
            <div className="insu-act-sec-bdy-rt  flex-sec">
              <span className="nsu-act-lbl">Document status:</span>
              <span className="nsu-act-val">
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select document status"
                  isClearable
                  options={buildOptions(docStatusList, 'id', 'val')}
                  value={getSelectedOption(
                    buildOptions(docStatusList, 'id', 'val'),
                    docStatus
                  )}
                  onChange={(opt) => setDocStatus(opt?.value ?? '')}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={selectMenuStyles}
                />
              </span>
            </div>
          </div>
          <div className="insu-act-sec-bdy-rw flex-sec alt-rw">
            <div className="insu-act-sec-bdy-lft flex-sec">
              <span className="nsu-act-lbl"> Document Type:</span>
              <span className="nsu-act-val">
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select document type"
                  isClearable
                  options={buildOptions(docTypeList, 'id', 'title')}
                  value={getSelectedOption(
                    buildOptions(docTypeList, 'id', 'title'),
                    docType
                  )}
                  onChange={(opt) => {
                    setDocType(opt?.value ?? '');
                    setDocName(opt?.label ?? '');
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={selectMenuStyles}
                />
              </span>
            </div>
            <div className="insu-act-sec-bdy-rt  flex-sec">
              <span className="nsu-act-lbl"> Allocate to user:</span>
              <span className="nsu-act-val">
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select user"
                  isClearable
                  options={buildAllocateUserOptions(allocateUserList)}
                  value={getGroupedSelectedOption(
                    buildAllocateUserOptions(allocateUserList),
                    userAllocated
                  )}
                  onChange={(opt) => setUserAllocated(opt?.value ?? '')}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={selectMenuStyles}
                />
              </span>
            </div>
          </div>
          <div className="insu-act-sec-bdy-rw flex-sec">
            <div className="insu-act-sec-bdy-lft flex-sec">
              <span className="nsu-act-lbl">Document Name:</span>
              <span className="nsu-act-val">
                <input
                  type="text"
                  className="inpt-width-nw"
                  placeholder="Document name"
                  value={docName || ''}
                  onChange={(e) => setDocName(e.target.value)}
                />
              </span>
            </div>
            <div className="insu-act-sec-bdy-rt  flex-sec">
              <span className="nsu-act-lbl">Document Date:</span>
              <span className="nsu-act-val">
                <ReactDatePicker
                  selected={docDate}
                  onChange={(date) => setDocDate(date)}
                  className="app-date-picker inpt-width-nw"
                  dateFormat={DEFAULT_DATE_FORMATE}
                />
              </span>
            </div>
          </div>
          <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
            <div
              className="insu-act-sec-bdy-lft flex-sec"
              style={{ height: '100px', overflowY: 'auto' }}
            >
              <span className="nsu-act-lbl">Notes:</span>
              {docsId ? (
                <>
                  <span className="nsu-act-val">
                    {docsNote &&
                      docsNote.map((note, i) => (
                        <div key={i} className="upld-doc-nte-con-nw">
                          <div className="upld-doc-nte-vlue-con-nw">
                            <i>
                              {`${note?.userName} ${note?.date} ${note?.time}`}
                            </i>
                          </div>
                          <div className="upld-doc-nte-vlue-commnt-nw">
                            {note?.userComment}
                          </div>
                        </div>
                      ))}
                  </span>
                  <span
                    className="nsu-act-lbl link-color"
                    onClick={() => setDocsNotePopUp(true)}
                    style={{ cursor: 'pointer' }}
                  >
                    Change Note
                  </span>
                </>
              ) : (
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="Write here..."
                    value={notes || ''}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="insu-act-sec-bdy-rw flex-sec justify-end item-center gap10 px-3">
          <Button variant="outline" onClick={close}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {docsId ? 'Update' : 'Save'}
          </Button>
        </div>
      </div>
      {patSerchPopup && (
        <PatientSerchPopUpForApp
          handleClosePatSerch={() => setPatSerchPopup(false)}
        />
      )}
      {docsNotePopUp && (
        <DocsNotePopup
          handleCloseDocsNote={() => setDocsNotePopUp(false)}
          docId={docsId}
          docsNote={docsNote}
          handleUpdateDocsNote={(newData) => setDocsNote(newData)}
        />
      )}
    </div>
  );
}

export default UploadDocPopUp;
